<template>
    <section class="booking booking--confirm">
        <div class="booking__main">
            <div class="booking-panel">
                <p class="booking__headline">{{ dictionary.BookingFlowConfirmBasketHeadline }}</p>
                <BookingBasket :customClass="'horizontal'" :department="department" :basket="basket"
                    :basketSummary="basketSummary" :padlockPrice="padlockPrice" :invitationCode="invitationCode"
                    :step="step" :steps="steps" v-bind="$attrs" />
            </div>
            <div class="booking-panel">
                <p class="booking__headline">{{ dictionary.BookingFlowCustomerFormHeadline }}</p>
                <div class="booking-confirm__customer-info">
                    <div class="grid">
                        <div class="col">
                            <p id="name">{{ dictionary.BookingFlowCustomerInfoFirstNameLabel }}</p>
                            <p aria-labelledby="name">{{ customerInfo.Name }}</p>
                        </div>
                    </div>
                    <div class="grid">
                        <div class="col">
                            <p id="address">{{ dictionary.BookingFlowCustomerInfoAddressLabel }}</p>
                            <p aria-labelledby="address">{{ customerInfo.Address }}</p>
                        </div>
                        <div class="col">
                            <p id="city">{{ dictionary.BookingFlowCustomerInfoCityLabel }}</p>
                            <p aria-labelledby="city">{{ customerInfo.City }}</p>
                        </div>
                    </div>
                    <div class="grid">
                        <div class="col">
                            <p id="zipCode">{{ dictionary.BookingFlowCustomerInfoZipCodeLabel }}</p>
                            <p aria-labelledby="zipCode>">{{ customerInfo.ZipCode }}</p>
                        </div>
                        <div class="col">
                            <p id="phone">{{ dictionary.BookingFlowCustomerInfoPhoneLabel }}</p>
                            <p aria-labelledby="phone">{{ customerInfo.Phone }}</p>
                        </div>
                    </div>
                    <div class="grid">
                        <div class="col">
                            <p id="email">{{ dictionary.BookingFlowCustomerInfoEmailLabel }}</p>
                            <p aria-labelledby="email>">{{ customerInfo.Email }}</p>
                        </div>
                        <div class="col">
                            <p id="phoneNextOfKin">{{ dictionary.BookingFlowCustomerInfoPhoneNextOfKinLabel }}</p>
                            <p aria-labelledby="phoneNextOfKin">{{ customerInfo.PhoneNextOfKin }}</p>
                        </div>
                    </div>
                    <Button class="p-button-secondary p-button-outlined p-button-rounded"
                        @click="handleStepChange(editInfoStep)">{{
                            dictionary.BookingFlowConfirmCustomerInfoEditButtonText
                        }}</Button>
                </div>

            </div>
        </div>

        <aside class="booking__aside" id="bookingConfirmActions">

            <div class="booking-panel">
                <div class="booking__conditions">
                    <p class="booking__headline">{{ dictionary.BookingFlowConfirmConditionsHeadline }}</p>
                    <p class="booking__message">{{ dictionary.BookingFlowConfirmConditionsMessage }}</p>
                    <Button class="p-button-primary p-button-rounded basket__button"
                        :class="{ 'p-button-secondary p-button-outlined': termsAccepted }"
                        @click="handleTermsAndConditionsClick()">{{
                            dictionary.BookingFlowConfirmConditionsButtonText
                        }}</Button>
                </div>

                <div v-if="termsAccepted">
                    <p class="booking__headline">{{ dictionary.BookingFlowConfirmOnLocationHeadline }}</p>
                    <p class="booking__message">{{ dictionary.BookingFlowConfirmOnLocationMessage }}</p>
                    <div class="grid">
                        <div class="col">
                            <Button class="p-button-primary p-button-rounded"
                                :class="{ 'p-button-secondary': isOnLocation != null && isOnLocation, 'p-button-secondary p-button-outlined': isOnLocation != null && !isOnLocation }"
                                @click="handleLocationClick(true)">{{
                                    dictionary.BookingFlowConfirmOnLocationTrueButtonText
                                }}</Button>
                        </div>
                        <div class="col">
                            <Button class="p-button-primary p-button-rounded"
                                :class="{ 'p-button-secondary': isOnLocation != null && !isOnLocation, 'p-button-secondary p-button-outlined': isOnLocation != null && isOnLocation }"
                                @click="handleLocationClick(false)">{{
                                    dictionary.BookingFlowConfirmOnLocationFalseButtonText
                                }}</Button>
                        </div>
                    </div>
                </div>

                <Button :disabled="creating" class="p-button-primary p-button-rounded basket__button"
                    v-if="termsAccepted && isOnLocation != null" @click="handleCreateLeaseClick">{{
                        dictionary.BookingFlowConfirmCreateLeaseButtonText
                    }}</Button>

                <BookingProgress :progress="progress"></BookingProgress>

            </div>
            <div class="booking-panel booking-panel--solar-powered" v-if="department.SolarPowered">
                <SolarPowered></SolarPowered>
            </div>
            <div class="booking-panel">
                <Help></Help>
            </div>
        </aside>
        <div class="booking-mobile-bar">
            <nav class="booking-mobile-bar__navigation">
                <span>&nbsp;</span>
                <Button v-if="!termsAccepted || isOnLocation == null"
                    class="p-button-primary p-button-rounded p-button-sm" @click="scrollToActions">Videre</Button>
                <Button v-if="termsAccepted && isOnLocation != null" :disabled="creating"
                    class="p-button-primary p-button-rounded p-button-sm" @click="handleCreateLeaseClick">{{
                        dictionary.BookingFlowConfirmCreateLeaseButtonText
                    }}</Button>
            </nav>
            <BookingProgress :progress="progress"></BookingProgress>
        </div>
    </section>
</template>
<script>
import bfdl from './../../bookingFlowDataLayer.js';
import bookingSteps from './../booking/bookingSteps.js';
import BookingBasket from "../components/bookingBasket.vue";
import Button from "primevue/button";
import Help from '../components/help.vue';
import SolarPowered from './../components/solarPowered.vue';
import ConfirmDialog from 'primevue/confirmdialog';
import Toast from 'primevue/toast';
import BookingProgress from './../components/bookingProgress.vue';
import MitID from './../../mitId.js';
import VueHelpers from './../vueHelpers.js';

export default {
    name: "confirm",
    components: {
        BookingBasket,
        Button,
        DataView,
        Help,
        SolarPowered,
        Toast,
        ConfirmDialog,
        BookingProgress
    },
    props: ["department", "progress", "basket", "basketSummary", "padlockPrice", "invitationCode", "step", "steps", "nextStep", "customerInfo", "isNewCustomer", "queryKeys", "referrer", "mitIDCodeTimestamp", "hasSeenNoAvailableRoomsMessage"],
    data() {
        return {
            dictionary: [],
            editInfoStep: null,
            isOnLocation: null,
            termsAccepted: false,
            termsAndConditions: "",
            showBasketOverlay: false,
            creating: false
        };
    },
    created() {
        const vm = this;
        vm.editInfoStep = bookingSteps.customer;

        var searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has(vm.queryKeys.onLocation)) {
            vm.isOnLocation = searchParams.get(vm.queryKeys.onLocation).toLowerCase() == "true";
        }

        window.dataLayer.push({
            'event': bfdl.getEventName(vm.referrer),
            'step': bfdl.steps.accept,
            'email': vm.customerInfo.Email,
            'rooms': bfdl.getRoomListFromBasket(vm.basket, vm.department)
        });

        fetch("/umbraco/api/dictionaryapi/GetConfirmDictionary").then((response) => response.json())
            .then((data) => {
                vm.dictionary = data;
            })
            .catch((error) => {
                console.log(error);
            });

        fetch("/umbraco/api/externalResourceApi/GetTradingConditions").then((response) => response.text())
            .then((data) => {
                vm.termsAndConditions = data;
            })
            .catch((error) => {
                console.log(error);
            });
    },
    mounted() {
        const vm = this;
        if (MitID.IsMitIDCallback()) {
            vm.$emit("toggleSpinner", true);
            vm.$emit("verifyMitID", { step: vm.steps.confirm, additionalQuery: `&${vm.queryKeys.onLocation}=${vm.isOnLocation}`, callback: vm.createLease });
        }
    },
    methods: {
        scrollToActions() {
            const isSmallScreen = window.matchMedia('(max-width: 768px)');
            let componentTop = document.querySelector('#bookingConfirmActions').offsetTop;
            if (isSmallScreen.matches) {
                componentTop -= 80;
            } else {
                componentTop -= 249;
            }

            window.scrollTo({
                top: componentTop,
                behavior: 'smooth',
            });
        },
        handleCreateLeaseClick() {
            const vm = this;

            const eventName = 'finalAccept';
            vm.$confirm.require({
                message: vm.dictionary.BookingFlowConfirmCreatePopupText,
                header: vm.dictionary.BookingFlowConfirmCreatePopupHeadline,
                acceptLabel: vm.dictionary.BookingFlowConfirmCreatePopupAcceptButtonText,
                rejectLabel: vm.dictionary.BookingFlowConfirmCreatePopupRejectButtonText,
                acceptClass: "p-button-primary p-button-rounded",
                rejectClass: "p-button-secondary p-button-rounded",
                accept: () => {
                    vm.creating = true;
                    window.dataLayer.push({
                        'event': eventName,
                        'value': 'accept',
                        'email': vm.customerInfo.Email,
                        'phone': vm.customerInfo.Phone,
                        'firstName': vm.customerInfo.Name,
                        'lastName': vm.customerInfo.Name,
                        'city': vm.customerInfo.City,
                        'zipCode': vm.customerInfo.ZipCode,
                        'rooms': bfdl.getRoomListFromBasket(vm.basket, vm.department),
                        'hasSeenNoAvailableRoomsMessage': vm.hasSeenNoAvailableRoomsMessage
                    });
                    vm.$emit("toggleSpinner", true);

                    if (vm.customerInfo.Id == null) {
                        //New customer, so it should be created first
                        console.log("Begin user creation");
                        fetch("/umbraco/api/customerapi/createCustomer", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify(vm.customerInfo)
                        }).then((response) => response.json())
                            .then((data) => {
                                //Login the new customer
                                fetch("/umbraco/api/LoginApi/VerifyCodeAndLoginUser", {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json"
                                    },
                                    body: JSON.stringify({ identifier: data.Identifier, code: data.Code })
                                }).then(response => {
                                    fetch("/umbraco/api/customerapi/GetCustomerProfile")
                                        .then((response) => response.json())
                                        .then((data) => {
                                            vm.$emit("customerInfoUpdated", data);
                                            vm.createLease();
                                        }).catch((error) => {
                                            console.log(error);
                                            vm.$emit("toggleSpinner", false);
                                            vm.creating = false;


                                        });
                                }).catch(error => {
                                    console.log(error);
                                    vm.creating = false;
                                    vm.$emit("toggleSpinner", false);
                                });
                            }).catch((error) => {
                                console.log(error);
                                vm.creating = false;
                                vm.$emit("toggleSpinner", false);
                            });
                    } else {
                        vm.createLease();
                    }
                },
                reject: () => {
                    window.dataLayer.push({
                        'event': eventName,
                        'value': 'decline',
                        'hasSeenNoAvailableRoomsMessage': vm.hasSeenNoAvailableRoomsMessage
                    });
                    vm.$toast.add({
                        severity: 'error', closable: false, summary: vm.dictionary.BookingFlowConfirmCreateRejectedNotificationTitle, detail: vm.dictionary.BookingFlowConfirmCreateRejectedNotificationText, life: 10000
                    });
                }
            });
        },
        createLease() {
            const vm = this;
            //If there is no MitID code, or it's older than 25 minutes, you must get a new one!
            if (
                !vm.customerInfo.MitIdCode ||
                (!MitID.IsMitIDCallback() &&
                    vm.customerInfo.MitIdCode != null &&
                    VueHelpers.getTimeDifferenceInSeconds(vm.mitIDCodeTimestamp) > 1500)
            ) {
                vm.$emit('initMitID', { step: vm.steps.confirm, additionalQuery: `&${vm.queryKeys.onLocation}=${vm.isOnLocation}` });
                return false;
            }

            vm.$emit("toggleSpinner", true);

            const baseUrl = window.location.origin + window.location.pathname;
            const requestBody = {
                Rooms: [],
                ReferralCode: vm.invitationCode,
                BamboraAcceptUrl: `${baseUrl}?${vm.queryKeys.step}=${vm.steps.end}&${vm.queryKeys.paymentSuccess}=true&${vm.queryKeys.onLocation}=${vm.isOnLocation}&${vm.queryKeys.isNewCustomer}=${vm.isNewCustomer}&${vm.queryKeys.referrer}=${vm.referrer}`,
                BamboraDeclineUrl: `${baseUrl}?${vm.queryKeys.step}=${vm.steps.end}&${vm.queryKeys.paymentSuccess}=false&${vm.queryKeys.onLocation}=${vm.isOnLocation}&${vm.queryKeys.isNewCustomer}=${vm.isNewCustomer}&${vm.queryKeys.referrer}=${vm.referrer}`,
                OnLocation: vm.isOnLocation,
                MitIdCode: vm.customerInfo.MitIdCode
            }

            vm.basket.forEach(entry => {
                requestBody.Rooms.push({
                    RoomId: entry.room.Id,
                    CouponCode: entry.discountCode,
                    IncludePadLock: entry.padlock
                })
            });

            fetch("/umbraco/api/bookingapi/PostCreateLease", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(requestBody)
            }).then(response => response.json())
                .then(data => {
                    if (data.status == 500) {
                        vm.creating = false;
                        vm.$emit("toggleSpinner", false);

                        for (const [key, value] of Object.entries(data.errors)) {

                            let errorMessage = vm.dictionary.BookingFlowErrorsGeneral;

                            switch (key) {
                                case 'customer':
                                    errorMessage = vm.dictionary.BookingFlowErrorCustomer;
                                    break;
                                case 'customer-invalid':
                                    errorMessage = vm.dictionary.BookingFlowErrorCustomerInvalid;
                                    break;
                                case 'customer-blocked':
                                    errorMessage = vm.dictionary.BookingFlowErrorCustomerBlocked;
                                    break;
                                case 'room-invalid':
                                    errorMessage = vm.dictionary.BookingFlowErrorRoomInvalid;
                                    break;
                                case 'room-not-available':
                                    errorMessage = vm.dictionary.BookingFlowErrorRoomNotAvailable;
                                    break;
                                case 'discount-coupon-invalid':
                                    errorMessage = vm.dictionary.BookingFlowErrorDiscountCouponInvalid;
                                    break;
                                default:
                                    errorMessage = vm.dictionary.BookingFlowErrorsGeneral;
                                    break;
                            }

                            vm.$toast.add({
                                severity: 'error', closable: false, summary: vm.dictionary.BookingFlowErrorsTitle, detail: errorMessage, life: 10000
                            });
                        }


                    } else {
                        bfdl.pushToDataLayer(bfdl.getEventName(vm.referrer), bfdl.steps.leaseCreated);

                        switch (data.type) {
                            case 0:
                            case 2:
                                bfdl.pushToDataLayer(bfdl.getEventName(vm.referrer), bfdl.steps.payment);
                                var bamboraScript = document.createElement('script');
                                bamboraScript.onload = function () {
                                    new Bambora.RedirectCheckout(data.token);
                                };
                                bamboraScript.src = 'https://static.bambora.com/checkout-sdk-web/latest/checkout-sdk-web.min.js';
                                document.head.appendChild(bamboraScript); //or something of the likes
                                vm.$emit("toggleSpinner", false);
                                break;
                            case 1:

                                //Alt det der med formularen her
                                if (data.savedCardMethod.toLowerCase() == 'post') {

                                    const formBody = new FormData();
                                    data.parameters.forEach(parameter => {
                                        formBody.append(parameter.Key, parameter.Value);
                                    })

                                    fetch(data.url, {
                                        method: 'POST',
                                        body: formBody
                                    }).then(response => {
                                        console.log(response);
                                    }).catch(error => {
                                        console.log(error);
                                    });

                                } else if (data.savedCardMethod.toLowerCase() == 'noredirect') {
                                    location.href = data.url;
                                }
                                vm.$emit("toggleSpinner", false);

                                break;
                            case 3:
                            case 4:
                                vm.$emit("toggleSpinner", false);

                                location.href = `${baseUrl}?${vm.queryKeys.step}=${vm.steps.end}&${vm.queryKeys.paymentSuccess}=true&${vm.queryKeys.onLocation}=${vm.isOnLocation}&${vm.queryKeys.isNewCustomer}=${vm.isNewCustomer}&${vm.queryKeys.referrer}=${vm.referrer}`;
                                break;
                            default:
                                break;
                        }
                    }

                }).catch(error => {
                    console.log(error);
                    vm.creating = false;
                    vm.$emit("toggleSpinner", false);
                });

        },
        handleStepChange(nextStep) {
            const vm = this;
            vm.$emit("stepChange", nextStep)

        },
        handleLocationClick(onLocation) {
            const eventName = 'armAlarm';
            window.dataLayer.push({
                'event': eventName,
                'value': onLocation.toString()
            });

            this.isOnLocation = onLocation;
        },
        handleTermsAndConditionsClick() {
            const vm = this;
            const eventName = 'termsAndConditions';
            vm.$confirm.require({
                message: vm.termsAndConditions,
                header: vm.dictionary.BookingFlowConfirmConditionsPopupHeadline,
                acceptLabel: vm.dictionary.BookingFlowConfirmConditionsPopupAcceptButtonText,
                rejectLabel: vm.dictionary.BookingFlowConfirmConditionsPopupRejectButtonText,
                acceptClass: "p-button-primary p-button-rounded",
                rejectClass: "p-button-secondary p-button-rounded",
                accept: () => {
                    window.dataLayer.push({
                        'event': eventName,
                        'value': 'accept'
                    });
                    vm.termsAccepted = true;
                },
                reject: () => {
                    window.dataLayer.push({
                        'event': eventName,
                        'value': 'decline'
                    });
                    vm.termsAccepted = false;
                    vm.$toast.add({
                        severity: 'error', closable: false, summary: vm.dictionary.BookingFlowConfirmConditionsRejectedNotificationTitle, detail: vm.dictionary.BookingFlowConfirmConditionsRejectedNotificationText, life: 10000
                    });
                }
            })
        }
    }
};
</script>
